import { motion } from 'framer-motion';
import SidebarGalleryPage from '../Main/Sidebargallery';
import Myimage from "../../assets/Career&Guidence/tnp_banner.jpg"


const recruitersData = [
  "GAIL (India) Ltd.",
  "IBM India",
  "Coal India Ltd.",
  "Birla Soft",
  "Bharat Sanchar Nigam Ltd.",
  "Cognizant Technology Solutions",
  "Bharat Heavy Electricals Ltd.",
  "HCL Technologies",
  "Bharat Electronics Ltd.",
  "Wipro Ltd",
  "Bharat Earth Movers Limited",
  "Infosys Technologies",
  "Airports Authority of India",
  "Tata Consultancy Services",
  "Microsoft India",
  "Air India",
  "Delhi Metro Rail Corporation",
  "Directorate General of Employment & Training (DGET)",
  "All India Council for Technical Education",
  "University Grants Commission (UGC)",
  "Maulana Azad National Institute of Technology, Bhopal (MANIT)",
  "NHPC Ltd.",
  "NTPC Ltd.",
  "Indian Oil Corporation Ltd.",
  "Online Employment Exchange (OLEX)",
  "Hindustan Petroleum Corpn. Ltd.",
  "Ideas for CM",
  "Fluor Daniel India Private Ltd.",
  "Admission & Fee Regulatory Committee (AFRC)",
  "Centre for Research & Industrial Staff Performance (CRISP)"
];

const recruitersImages = [
    "/public/img1forrecruiters_page.jpg",
    "path/to/sit_expressn_logo.jpg",
    "path/to/magnum_group_logo.jpg",
    "path/to/bio_diversity_logo.jpg",
    "path/to/anand_mills_logo.jpg",
    "path/to/sagar_public_school_logo.jpg",
    "path/to/signature_builders_logo.jpg",
    "path/to/technical_education_logo.jpg",
    "path/to/yemota_systems_logo.jpg",
    "path/to/pp_systems_logo.jpg",
    "path/to/crisp_logo.jpg",
    "path/to/normat_logo.jpg"
  ];
  

export default function RecruitersPage() {
  return (
    <div className="min-h-screen bg-gray-100 p-12">
      <div className="flex flex-col lg:flex-row gap-10">
        {/* Recruiters List */}
        <motion.div
          className="lg:col-span-2"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <img
            src={Myimage}
            alt="Career Guidance & Placement Cell Banner"
            className="w-full rounded-lg border-4 border-teal-500 p-2 mb-10"
          />

          {/* <hr className="mt-7 mb-2 border-t border-dotted border-gray-400" /> */}

          <div className="border-4 border-teal-500 p-2 rounded-lg">
            <h2 className="text-2xl font-bold mb-4 text-white bg-[#00BFA5] p-2 rounded-sm">
              Career Opportunity
            </h2>
            <div className="recruiters-list">
              {/* <h2 className="text-2xl font-bold mb-4">Our Recruiters</h2> */}
              <ul className="list-decimal list-inside mb-6 ">
                {recruitersData.map((recruiter, index) => (
                  <li key={index} className="text-lg font-semibold ml-4 mb-2">
                    {recruiter}
                  </li>
                ))}
              </ul>
            </div>

            <div className="recruiters-gallery mt-4 p-4">
              {/* <h2 className="text-2xl font-bold mb-4">Gallery</h2> */}
              <div className="grid grid-cols-4 gap-4">
                {recruitersImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`${recruitersData[index]} Logo`}
                    className="w-full h-auto rounded object-contain max-h-24"
                  />
                ))}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Sidebar - Gallery */}
        <SidebarGalleryPage></SidebarGalleryPage>
      </div>
    </div>
  );
}
